// @ts-nocheck

import { reduce as _reduce } from 'lodash';

import { BasketStatuses, BasketItemStatuses } from '../../../types/basket';

/**
 * Return the nextState corresponding to the
 * BASKET_SET_ITEM_STATUS_ERROR action
 *
 * @static
 * @param  {Object} state  The actual state
 * @param  {Object} action The action to reduce
 * @return {Object}        Return the new state.
 */
const basketSetItemStatusError = (state, action) => {
  const { items } = state;
  const { oddId, error: nextError } = action.payload;
  if (items[oddId] !== undefined) {
    const item = items[oddId];
    const { status: itemStatus, error: itemError } = item;
    if (itemStatus !== BasketItemStatuses.ERROR || itemError !== nextError) {
      const nextItems = {
        ...items,
        [oddId]: {
          ...item,
          status: BasketItemStatuses.ERROR,
          error: nextError,
          betslipId: undefined,
          additionalMessage: undefined,
          eligibleKLCollectibleId: null,
        },
      };

      const nextStatus = _reduce(
        nextItems,
        (finalStatus, currentItem) => {
          if (currentItem.status === BasketItemStatuses.PENDING && !currentItem.cashout) {
            return BasketStatuses.PENDING;
          }
          return finalStatus;
        },
        BasketStatuses.OK,
      );

      return {
        ...state,
        items: nextItems,
        status: nextStatus,
      };
    }
  }
  return state;
};

export default basketSetItemStatusError;
